import React from 'react'

const BannerLanding = (props) => (
    <section id="banner" className="style2">
        <div className="inner">
            <header className="major">
                <h1>Medical Equipment Workflow Management System</h1>
            </header>
            <div className="content">
                <p>comprehensive asset management system for medical device service providers</p>
            </div>
        </div>
    </section>
)

export default BannerLanding
